import React from 'react';

import VideoIcon from '@atlaskit/icon/core/video';
import { token } from '@atlaskit/tokens';

export const LoomVideoGlyph = (): React.JSX.Element => (
	<VideoIcon label="" color={token('color.icon.brand')} size="medium" spacing="none" />
);
